import { AxiosResponse } from 'axios'

export const namespaced = true

interface RemittanceChatState {
  pending: Promise<AxiosResponse>[]
}

export const state = {
  pending: [] as Promise<AxiosResponse>[],
} as RemittanceChatState

export const mutations = {
  addPending: (state: RemittanceChatState, payload: Promise<AxiosResponse>) => {
    state.pending.push(payload)
  },
  removePending: (
    state: RemittanceChatState,
    payload: Promise<AxiosResponse>,
  ) => {
    const index = state.pending.findIndex(promise => promise === payload)
    if (index > -1) {
      state.pending.splice(index, 1)
    }
  },
}

export const getters = {}

export const actions = {}
